import { useState } from 'react';
import { FileText, Loader2 } from 'lucide-react';
import { useAuth } from '@/lib/AuthContext';
import ForgotPassword from '@/pages/ForgotPassword';

/**
 * Sign-in.
 *
 * New in the rebuild: Base44 redirected to its own hosted login page, which
 * does not exist once the app is self-hosted. Accounts are created by an admin
 * inviting someone from the Supabase dashboard — there is deliberately no
 * sign-up here.
 */
export default function SignIn() {
  const { signIn, error: authError } = useAuth();
  const [resetting, setResetting] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setBusy(true);
    try {
      await signIn(email.trim(), password);
    } catch (err) {
      setError(err.message || 'Could not sign in.');
    } finally {
      setBusy(false);
    }
  };

  if (resetting) return <ForgotPassword onDone={() => setResetting(false)} />;

  return (
    <div className="signin-shell">
      <form className="signin-card" onSubmit={handleSubmit}>
        <div className="signin-brand">
          <FileText size={36} />
          <div>
            <h1>EDDM Organizer</h1>
            <p>USPS Mail Management</p>
          </div>
        </div>

        {(error || authError) && <div className="alert alert-error">{error || authError}</div>}

        <div className="form-group">
          <label className="form-label" htmlFor="email">
            Email
          </label>
          <input
            id="email"
            className="form-input"
            type="email"
            autoComplete="username"
            required
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </div>

        <div className="form-group">
          <label className="form-label" htmlFor="password">
            Password
          </label>
          <input
            id="password"
            className="form-input"
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </div>

        <button className="btn btn-primary signin-submit" type="submit" disabled={busy}>
          {busy ? <Loader2 size={18} className="spin" /> : null}
          {busy ? 'Signing in...' : 'Sign in'}
        </button>

        <p className="signin-help">
          <button type="button" className="link-button" onClick={() => setResetting(true)}>
            Forgot your password?
          </button>
          <br />
          Accounts are created by an administrator. If you cannot get in, ask them to add you.
        </p>
      </form>
    </div>
  );
}
